"use client";

import {
    CarouselContentVisible,
    CarouselItem,
} from "~/components/ui/carousel";
import Carousel from "~/componentsDS/Carousel";
import type { Journal } from "~/lib/medicalJournals/getMedicalJournals";

import MedicalJournalCard from "./MedicalJournalCard";

type MedicalJournalsCarouselProps = {
    journals: Journal[];
};

export default function MedicalJournalsCarousel({
    journals,
}: MedicalJournalsCarouselProps) {
    return (
        <Carousel
            loop={false}
            desktopWheelGestures
            opts={{
                align: "start",
                containScroll: "trimSnaps",
                skipSnaps: false,
            }}
        >
            <CarouselContentVisible className="ml-0 gap-4 px-6 md:px-12 xl:px-16 min-[1440px]:px-20">
                {journals.map((journal) => (
                    <CarouselItem
                        key={journal.link}
                        className="pl-0 basis-[240px]"
                    >
                        <MedicalJournalCard journal={journal} />
                    </CarouselItem>
                ))}
            </CarouselContentVisible>
        </Carousel>
    );
}
